<template>
    <div class="detail-box">
        <div class="banner-box">
            <p class="examine-name">{{ detail.examineName }}</p>
            <div class="label-status" :style="`background-color:${filterStatus(detail.examineStatus).color};`">{{
                filterStatus(detail.examineStatus).label }}</div>
            <div class="hr"></div>
            <div class="banner-item" style="margin-left: 0;">
                <p>任务完成度</p>
                <p>{{ detail.taskComplete }}</p>
            </div>
            <div class="banner-item">
                <p>任务合格率</p>
                <p>{{ detail.taskPassRate }}</p>
            </div>
            <div class="banner-item">
                <p>总分</p>
                <p>{{ detail.fullScore }}</p>
            </div>
            <div class="banner-item">
                <p>及格分</p>
                <p>{{ detail.passScore }}</p>
            </div>
        </div>
        <div class="center-container">
            <i class="iconfont icon-zhankai1 scrool-left" v-if="showLeft" @click.stop="scroolBy('right')"></i>
            <i class="iconfont icon-zhankai1 scrool-right" v-if="showRight" @click.stop="scroolBy('left')"></i>
            <no-data style="height: calc(100% - 8rem);" v-if="!detail.examineDetailList||detail.examineDetailList.length==0"></no-data>
            <div class="center-box" v-if="detail.examineDetailList&&detail.examineDetailList.length>0">
                <div v-for="(item, index) in detail.examineDetailList && detail.examineDetailList"
                    :class="{ active: currentSoftwareItem.softwareId == item.softwareId }" @click="changeSoftwore(item)" class="soft-item" :key="index">
                    <div class="flag-box" :style="`background-color:${item.resourceType=='0'?'rgba(103, 194, 58,0.8)':'rgba(230, 162, 60,0.8)'};`">{{ item.resourceType=='0'?'理论':'虚仿' }}</div>
                    <el-tooltip effect="dark" :content="item.resourceName" placement="top-start">
                        <p class="soft-item-title overflow">{{ item.resourceName }}</p>
                    </el-tooltip>
                    <div class="soft-item-center">
                        <p :class="{ white: currentSoftwareItem.softwareId == item.softwareId }">合格率:</p>
                        <p>{{ item.passRate }}</p>
                    </div>
                    <div class="soft-item-bottom">
                        <div class="bottom-left">
                            <p :class="{ white: currentSoftwareItem.softwareId == item.softwareId }">应考人数</p>
                            <p>{{ item.shouldSum }}</p>
                        </div>
                        <div class="bottom-right">
                            <p :class="{ white: currentSoftwareItem.softwareId == item.softwareId }">已考人数</p>
                            <p>{{ item.completedSum }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-box" v-if="detail.examineDetailList&&detail.examineDetailList.length>0">
            <div class="bottom-box-top">
                <p>{{ currentSoftwareItem.resourceName }}</p>
                <div style="display: flex;align-items: center;">
                    <div class="grey">(单项得分占比</div>
                    <div>{{ currentSoftwareItem.scoreRatio }}</div>
                    <div class="spot"></div>
                    <div class="grey">单项总分</div>
                    <div>{{ currentSoftwareItem.fullScore }}</div>
                    <div class="spot"></div>
                    <div class="grey">单项及格分</div>
                    <div>{{ currentSoftwareItem.passScore }}</div>
                    <div class="grey">)</div>
                </div>
                <div class="btn-box" @click="exportGrade">导出成绩</div>
            </div>
            <div class="table-content-box">
                <Table :totalSize="pages.total" :pagination="true" :serialNumber="true" :operationWidth="350"
                    :currentPage="pages.current" @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize"
                    :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="currentSoftwareItem.resourceType=='1'?tableKey:tableKey1">
                    <template slot="userName" slot-scope="data">
                        <p>{{ data.data.row.userName||'/' }}</p>
                    </template>
                    <template slot="classNames" slot-scope="data">
                        <p>{{ data.data.row.classNames||'/' }}</p>
                    </template>
                    <template slot="examineTime" slot-scope="data">
                        <p>{{ data.data.row.examineTime||'/' }}</p>
                    </template>
                    <template slot="totalRatioScore" slot-scope="data">
                        <p>{{ data.data.row.totalRatioScore==null?'/':data.data.row.totalRatioScore }}</p>
                    </template>
                    <template slot="ratioScore" slot-scope="data">
                        <p>{{ data.data.row.ratioScore==null?'/':data.data.row.ratioScore }}</p>
                    </template>
                    <template slot="score" slot-scope="data">
                        <p>{{ data.data.row.score==null?'/':data.data.row.score }}</p>
                    </template>
                    <template slot="status" slot-scope="data">
                        <p>{{ data.data.row.score===null?'未考':'已考' }}</p>
                    </template>
                    <template slot="operation" slot-scope="data">
                        <div class="operation-box">
                            <el-tooltip class="item" effect="dark" content="查看得分详情" placement="top-start">
                                <i class="iconfont icon-chakan" v-if="currentSoftwareItem.resourceType=='1'" @click="viewScoreDetail(data.data.row)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="重考" placement="top-start">
                                <i class="iconfont icon-reset" v-if="currentSoftwareItem.resourceType=='0'" @click="makeupTest(data.data.row)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="得分详情" placement="top-start">
                                <i class="iconfont icon-xiangqing" v-if="currentSoftwareItem.resourceType=='0'&&data.data.row.score!=null" @click="scoreDetail(data.data.row)"></i>
                            </el-tooltip>
                        </div>
                    </template>
                </Table>
            </div>
        </div>
        <score-detail ref="score_detail"></score-detail>
        <theory-detail :detail="theoryDetail" ref="theory_detail"></theory-detail>
    </div>
</template>

<script>
import { PageQuerySoftwareScore,GetSoftwareScoreTree,ExaminePaperScorePage,ExaminationReset,GetSynthExamineDetailById,ExamineScoreExport } from '@/api/examine';
import { GetTestPaperQuestion,GetUserAnswerRecord  } from '@/api/paper';
import ScoreDetail from '../virtual/ScoreDetail.vue';
import NoData from '../../../common/NoData.vue';
import {download} from '@/utils/utils';
import TheoryDetail from '../../../personCenter/myselfTask/TheoryDetail.vue';
export default {
  components: { ScoreDetail, NoData, TheoryDetail },
    data() {
        return {
            detail: {},
            /**考核id */
            examineId: '',
            recordId:'',
            userId:'',
            theoryDetail:{},
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            showLeft:false,
            showRight:false,
            /**当前选中仿真软件 */
            currentSoftwareItem: {},
            tableData: [],
            tableKey: [
                {
                    name: '姓名',
                    value: 'userName',
                    slot:'userName'
                },
                {
                    name: '班级',
                    value: 'classNames',
                    slot:'classNames'
                },
                {
                    name: '考核用时',
                    value: 'examineTime',
                    slot:'examineTime'
                },
                {
                    name: '考核总分',
                    value: 'totalRatioScore',
                    slot:'totalRatioScore'
                },
                {
                    name: '单项占比得分',
                    value: 'ratioScore',
                    slot:'ratioScore'
                },
                {
                    name: '单项得分',
                    value: 'score',
                    slot:'score'
                },
                {
                    name: '操作',
                    value: 'operation',
                    slot:'operation'
                },
            ],
            tableKey1:[
                {
                    name: '用户名称',
                    value: 'userName'
                },
                {
                    name: '班级',
                    value: 'className'
                },
                {
                    name: '得分',
                    value: 'score',
                    slot:'score'
                },
                {
                    name: '考核状态',
                    value: 'status',
                    slot:'status'
                },
                {
                    name: '开始时间',
                    value: 'startTime',
                    width: '200'
                },
                {
                    name: '结束时间',
                    value: 'endTime',
                    width: '200'
                },
                {
                    name: '操作',
                    value: 'operation',
                    slot: 'operation'
                },
            ]
        }
    },
    methods: {
         /**导出成绩 */
         exportGrade(){
            ExamineScoreExport({examineId:this.examineId}).then(res=>{
                download(res.data,this.detail.examineName);
            })
        },

        filterStatus(status) {
            var obj = {
                0: {
                    label: '未开始',
                    color: '#C2C7D9'
                },
                1: {
                    label: '进行中',
                    color: '#387DFF'
                },
                2: {
                    label: '已结束',
                    color: '#67C23A'
                },
            }
            return obj[status] || {};
        },
        /**补考 */
        makeupTest(data) {
            this.$confirm('是否确认重置考试?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    "examineId": this.examineId,
                    "userId": data.userId
                }
                ExaminationReset(params).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            message: "重置考试成功",
                            type: "success",
                        });
                        GetSynthExamineDetailById({id:this.examineId}).then(res=>{
                            res.data.examineDetailList.forEach(item=>{
                                    item.softwareId=item.resourceId;
                                    delete item.resourceId;
                                })
                                this.detail=res.data;
                                this.listenerScrool();
                                this.examinePaperScorePage();
                        })
                    }
                })
            });
        },
        /**得分详情 */
        scoreDetail(data){
            this.userId=data.userId;
            let dialog=this.$refs.theory_detail;
            if(dialog){
                this.getUserAnswerRecord();
            }
        },
         /**获取试卷题目数据 */
         getTestPaperQuestion() {
            return new Promise(resolve => {
                var params={
                    "businessId":this.examineId+'-'+this.currentSoftwareItem.softwareId,
                    "testPaperId":this.currentSoftwareItem.softwareId,
                    "userId":this.userId,
                    "testPaperRecordId":this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.theoryDetail = res.data;
                        let dialog=this.$refs.theory_detail;
                        if(dialog){
                            dialog.dialogVisible=true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
         /**获取用户答题记录 */
         getUserAnswerRecord() {
            return new Promise(resolve=>{
                var params = {
                "businessId": this.examineId+'-'+this.currentSoftwareItem.softwareId,
                "testPaperId": this.currentSoftwareItem.softwareId,
                "userId":this.userId,
                "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async(res) => {
                    if (res.code == 200) {
                        this.recordId=res.data.id;
                        await this.getTestPaperQuestion(this.examineId);
                        this.$set(this.theoryDetail,'userQuestionScoreVOS',res.data.userQuestionScoreVOS);
                        let startTime=new Date(res.data.startTime).getTime();
                        let endTime=new Date(res.data.endTime).getTime();
                        let userTestTime=(endTime-startTime)/1000;
                        this.$set(this.theoryDetail,'userTestTime',userTestTime);
                        let questionDetailVOS = this.theoryDetail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**滚动 */
        scroolBy(px){
            let dom=document.querySelector('.center-box');
            let dom1=document.querySelector('.center-container');
            let width=dom1.clientWidth+50;
            if(dom){
                dom.scrollBy({
                        left: px=='left'?width:-width,
                        behavior:'smooth'
            });
            }
        },
        isShowScrool(){
            this.$nextTick(()=>{
                let dom=document.querySelector('.center-box');
                let clientWidth=dom.clientWidth;
                let scrollLeft=dom.scrollLeft;
                let scrollWidth=dom.scrollWidth;
                let gap=Math.abs(clientWidth+scrollLeft-scrollWidth);
                if(scrollLeft==0){
                    this.showLeft=false;
                }else{
                    this.showLeft=true;
                }
                if(gap<20){
                    this.showRight=false;
                }else{
                    this.showRight=true;
                }
            })
        },
        listenerScrool(){
            this.$nextTick(()=>{
                let dom=document.querySelector('.center-box');
                dom&&dom.addEventListener('scroll',this.isShowScrool);
                this.isShowScrool();
            })
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.pageResData();
        },
        /**实训得分数查询 */
        getSoftwareScoreTree(data){
           return new Promise((resolve)=>{
                let params={
                    examineId:this.examineId,
                    softwareId:this.currentSoftwareItem.softwareId,
                    userId:data.userId
                }
                GetSoftwareScoreTree(params).then(res=>{
                    if(res.code==200){
                        resolve(res.data);
                    }
                })
           })
        },
        changePageSize(e) {
            this.pages.current = 1;
            this.pages.size = e;
            this.pageResData();
        },
        /**查看得分详情 */
        viewScoreDetail(data){
            this.getSoftwareScoreTree(data).then(res=>{
                let dialog=this.$refs.score_detail;
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.detail=res;

                }
            });
            
        },
        /**切换仿真软件 */
        changeSoftwore(item){
            this.currentSoftwareItem=item;
            this.pageResData();
        },
        pageResData(){
            if(this.currentSoftwareItem.resourceType=='1'){
                this.pageQuerySoftwareScore();
            }else{
                this.examinePaperScorePage();
            }
        },
        /**分页查询虚仿考核得分 */
        pageQuerySoftwareScore() {
            let params = {
                "current": this.pages.current,
                "examineId": this.examineId,
                "size": this.pages.size,
                "softwareId": this.currentSoftwareItem.softwareId
            }
            PageQuerySoftwareScore(params).then(res => {
                if (res.code == 200) {
                    this.pages.total=res.data.total;
                    this.tableData=res.data.records;
                }
            })
        },
        /**分页查询理论考核学生成绩 */
        examinePaperScorePage() {
            let params = {
                "current": this.pages.current,
                "examineId": this.examineId,
                "size": this.pages.size
            };
            ExaminePaperScorePage(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.tableData.forEach(item=>{
                        for(let key in item){
                            if(item[key]==null&&key!='score'){
                                item[key]='/';
                            }
                        }
                    })
                    this.pages.total = res.data.total;
                }
            })
        },
    },
    destroyed(){
        let dom=document.querySelector('.center-box');
        dom&&dom.removeEventListener('scroll',this.isShowScrool);
    }
}
</script>

<style lang="less" scoped>
.detail-box {
    height: 100%;
    color: #334681;

    .banner-box {
        height: 8rem;
        background: #ffffff;
        border: 1px solid #edf3f9;
        border-radius: 1rem;
        padding: 0 3rem;
        display: flex;
        align-items: center;
    }
}

.label-status {
    padding: 0.2rem 0.2rem;
    border-radius: 0.2rem;
    color: #ffffff;
    margin-left: 1.7rem;
}

.examine-name {
    font-size: 1.8rem;
    font-weight: 700;
}

.hr {
    width: 1px;
    height: 2rem;
    background-color: #C2C7D9;
    margin: 0 3rem;
}

.banner-item {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 6rem;

    &> :nth-child(2) {
        font-weight: 700;
        color: #D5698A;
        font-size: 16px;
        margin-left: 2.7rem;
    }
}

.center-box {
    display: flex;
    margin: 2.5rem 0;
    overflow: hidden;
    width: 100%;
    position: relative;
    &> :nth-child(n) {
        margin-left: 2.5rem;
    }
    &> :nth-child(1) {
        margin-left: 0;
    }
}
.center-container{
    position: relative;
    .scrool-right{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 3rem;
        cursor: pointer;
        z-index: 99;
    }
    .scrool-left{
        position: absolute;
        left: 0;
        top: 50%;
        transform:translateY(-50%) rotate(180deg);
        font-size: 3rem;
        cursor: pointer;
        z-index: 99;
    }
}

.soft-item {
    width: calc((100% - 10rem)/5);
    flex-shrink: 0;
    height: 16rem;
    background: #ffffff;
    border: 1px solid #edf3f9;
    border-radius: 1rem;
    box-shadow: 0px 0px 1.5rem 0px rgba(231, 236, 239, 0.10);
    cursor: pointer;
    padding: 3rem;
    position: relative;
    overflow: hidden;
    .flag-box{
        position: absolute;
        top: 1rem;
        right: 1rem;
        border-radius:50%;
        padding: 0.5rem;
        color: #ffffff;
    }

    .soft-item-title {
        font-weight: 700;
        font-size: 1.8rem;
        width: 95%;
    }

    .soft-item-center {
        display: flex;
        margin-top: 1.5rem;

        &> :nth-child(1) {
            color: #8590B3;
        }

        &> :nth-child(2) {
            font-weight: 700;
        }
    }

    .soft-item-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 2.3rem;

        .bottom-left,
        .bottom-right {
            display: flex;

            &> :nth-child(1) {
                color: #8590B3;
            }

            &> :nth-child(2) {
                font-weight: 700;
                margin-left: 1.3rem;
            }
        }
    }
}

.bottom-box {
    height: calc(100% - 29rem);
    background: #ffffff;
    border: 1px solid #edf3f9;
    border-radius: 1rem;
    padding: 2.5rem 3rem;
}

.bottom-box-top {
    display: flex;
    align-items: center;
    font-size: 16px;
    position: relative;
    &> :nth-child(1) {
        font-weight: 700;
        font-size: 1.8rem;
    }
}

.grey {
    color: #8590B3;
}

.spot {
    width: 0.3rem;
    height: 0.3rem;
    margin: 0 0.5rem;
    border-radius: 50%;
    background-color: #334681;
}

.table-content-box {
    margin-top: 2.5rem;
    height: calc(100% - 5rem);
}

.active {
    background-color: var(--blue) !important;
    color: #ffffff;
}

.white {
    color: #ffffff !important;
}
.operation-box{
    i{
        color: var(--blue);
        cursor: pointer;
        font-size: 1.8rem;
    }
    &> :nth-child(n){
        margin-left: 1.5rem;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
}
.btn-box {
    width: 12rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    margin-bottom: 2rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
</style>